import { render, staticRenderFns } from "./activeSet.vue?vue&type=template&id=04b1744f&"
import script from "./activeSet.vue?vue&type=script&lang=js&"
export * from "./activeSet.vue?vue&type=script&lang=js&"
import style0 from "./activeSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports